export const state = {
    grupoFinanceiro: {},
    gruposFinanceiro: [],
    modalExcluirGrupoFinanceiro: false,
    modalCadastroGrupoFinanceiro: false,
}

export default {}